export default __webpack_public_path__ + "static/media/bg-hero-home.1171cde7.jpeg";